import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import PricingPlans from '../components/home/home_PricingPlans';

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Navbar", "Navbar_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Navbar || { Main: {} };

  return (
    <div>
      <title>{LANGUAGE.Main.Content19 || "方案價格"}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <PricingPlans />
    </div>
  );
};

export default Page;
